// src/modules/app-views/serviceOrders/pages/Init/actions/menuButton.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { dropdownDivider } from 'layouts/Pages/PageHeader/dropdownMenus';
import { FilterOutlined } from '@ant-design/icons';

// *******************************************************************************
// MENU BUTTON
// *******************************************************************************
const serviceOrdersInitMenuButton = () => {
  return {
    action: 'dropdownMenu',
    dropdownItems: [
      {
        key: 'clearFilters',
        label: 'clear_filters',
        icon: <FilterOutlined />,
        onClick: ({ listContext }) => {
          listContext?.clearFilters?.();
        },
      },
    ],
  };
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default serviceOrdersInitMenuButton;
